export default "/_next/static/images/down-arrow-c83e61b425074480753285fcbda53888.svg";